import clsx from 'clsx';
import React from 'react';
import { ButtonLink } from '../../_shared/ButtonLink.js';
import styles from './CollapseButton.module.scss';
import { IconUp } from './IconUp.js';
import { Button } from '../../../base-components/Button.js';
import { SettingsIcon } from '../../Icons/index.js';

interface Props {
  collapsed: boolean;
  onClick?: () => void;
}

/* <ButtonLink className={clsx(styles.button, className)} onClick={onClick}>
  {collapsed ? 'Расширенный поиск' : 'Свернуть'} <IconUp flip={collapsed} />
</ButtonLink> */
export const CollapseButton: React.FC<Props> = ({ collapsed, onClick }) => (
  <div>
    <Button variant="stroke" className={styles.button} onClick={onClick}>
      <SettingsIcon />
    </Button>
  </div>
);
